import { __assign, __rest } from "tslib";
import React from 'react';
import { CONCEALED_ICON, REVEALED_ICON } from '@marvelapp/theme';
import { Box, CircleButton, Icon, Tooltip } from '@marvelapp/ui';
export default function CollapseExpandButton(_a) {
    var isLastChild = _a.isLastChild, isCollapsed = _a.isCollapsed, props = __rest(_a, ["isLastChild", "isCollapsed"]);
    return (React.createElement(Box, { marginRight: isLastChild ? 0 : 2 },
        React.createElement(Tooltip, { content: isCollapsed ? 'Expand section' : 'Collapse section' },
            React.createElement(CircleButton, __assign({ bg: "white", "data-testid": "collapse-expand-button", hoverBg: "white" }, props),
                React.createElement(Icon, { display: "block", paths: isCollapsed ? REVEALED_ICON : CONCEALED_ICON })))));
}
